// extracted by mini-css-extract-plugin
export default {"icon":"SidebarArt_icon__R3YtV"};